import { axios, createAsyncThunk } from '../thunk-config';

export default createAsyncThunk(
  'transaction/processPaypalOrder',
  async ({ transaction_token, order_id, headers }, { rejectWithValue }) => {
    try {
      // If using doAddProcessOrder
      const response = await axios.post(
        `/utilv2/paypal_process_order`,
        {
          transaction_token,
          order_id,
        },
        { headers }
      );

      if (response.data.data) {
        return { ...response.data };
      } else {
        return rejectWithValue({
          message: 'Internal server error',
          data: response.data,
        });
      }
    } catch (err) {
      if (!err.response) {
        throw err;
      }

      return rejectWithValue(err.response.data);
    }
  }
);



// WEBPACK FOOTER //
// ./client/resources/js/checkout/redux/thunks/processPaypalOrder.js